/**
 * Onde o painel de demonstração pode aparecer.
 *
 * Requisito: visível em desenvolvimento e em staging, **nunca em produção**.
 *
 * `import.meta.env.DEV` não resolve isso sozinho — ele é falso em qualquer
 * build, inclusive o de staging. Por isso a decisão é explícita e testável,
 * e não uma condição espalhada pelos componentes.
 *
 * O padrão é ESCONDER: um ambiente desconhecido, ou uma variável mal escrita,
 * resultam em painel oculto. Vazar controles de papel e de estado para os 19
 * participantes seria pior do que perdê-los em staging.
 */

export type AppEnvironment = 'development' | 'staging' | 'production' | 'unknown';

export function parseEnvironment(raw: string | undefined, isDev: boolean): AppEnvironment {
  if (isDev) return 'development';

  switch (raw) {
    case 'development':
    case 'staging':
    case 'production':
      return raw;
    default:
      return 'unknown';
  }
}

/** Só desenvolvimento e staging. Qualquer outra coisa: não. */
export function isDemoPanelAllowed(environment: AppEnvironment): boolean {
  return environment === 'development' || environment === 'staging';
}

export function currentEnvironment(): AppEnvironment {
  return parseEnvironment(
    import.meta.env['VITE_APP_ENV'] as string | undefined,
    import.meta.env.DEV,
  );
}

export function showDemoPanel(): boolean {
  return isDemoPanelAllowed(currentEnvironment());
}
